<template>
  <div class="print-break-after">
    <!-- 
      Div a scomparsa per mostrare un'immagine utilizzando tutta la finestra popup
    -->
    <div v-if="tabToShow === 'pic'" class="wg-row pic-viewer">
      <img
        style="width:100%;height:100%;object-fit:contain;object-position:center;cursor:zoom-out;"
        :src="$anm22.getImagePath(picToShow, false)"
        @click="closePic"
      />
    </div>
    <!-- 
      Div principale, gestione spesa mediante modal
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <template v-if="!this.project.category || this.project.category != 2">
        <template v-if="mode != 'prod'">
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Model", "Modello") }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <input
                :disabled="mode === 'view'"
                class="input-elem com-anm22-app-input-text model-row"
                type="text"
                v-model="formData.model"
              />
            </div>
          </div>
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Perforations", "Traforatura") }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  :disabled="mode === 'view'"
                  id="perf-no"
                  type="radio"
                  value="no"
                  style="display:none;"
                  v-model="formData.perforations"
                />
                <label class="label-input-radio" for="perf-no">{{
                  formData.perforations === "no" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "None", "Nessuna") }}
                </div>
                <template v-if="formData.perforations === 'medium'">
                  <div
                    class="com-anm22-horizontal-div"
                    style="width: 20px;"
                  ></div>
                  <input
                    :disabled="mode === 'view'"
                    id="perf-m"
                    type="radio"
                    value="medium"
                    style="display:none;"
                    v-model="formData.perforations"
                  />
                  <label class="label-input-radio" for="perf-m">{{
                    formData.perforations === "medium" ? "✔" : ""
                  }}</label>
                  <div class="com-anm22-app-text-m" style="margin:0 5px;">
                    {{ $anm22.strLang(lang, "Medium", "Media") }}
                  </div>
                </template>
                <template v-if="formData.perforations === 'total'">
                  <div
                    class="com-anm22-horizontal-div"
                    style="width: 20px;"
                  ></div>
                  <input
                    :disabled="mode === 'view'"
                    id="perf-t"
                    type="radio"
                    value="total"
                    style="display:none;"
                    v-model="formData.perforations"
                  />
                  <label class="label-input-radio" for="perf-t">{{
                    formData.perforations === "total" ? "✔" : ""
                  }}</label>
                  <div class="com-anm22-app-text-m" style="margin:0 5px;">
                    {{ $anm22.strLang(lang, "Total", "Totale") }}
                  </div>
                </template>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="perf-bp"
                  type="radio"
                  value="beforePrint"
                  style="display:none;"
                  v-model="formData.perforations"
                />
                <label class="label-input-radio" for="perf-bp">{{
                  formData.perforations === "beforePrint" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{
                    $anm22.strLang(lang, "Before print", "Prima della stampa")
                  }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="perf-ap"
                  type="radio"
                  value="afterPrint"
                  style="display:none;"
                  v-model="formData.perforations"
                />
                <label class="label-input-radio" for="perf-ap">{{
                  formData.perforations === "afterPrint" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "After print", "Dopo la stampa") }}
                </div>
              </div>
            </div>
          </div>
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(lang, "Print treatment", "Trattamento stampa")
                }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  :disabled="mode === 'view'"
                  id="treatment-no"
                  type="radio"
                  value="0"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-no">{{
                  !formData.printTreatment || formData.printTreatment == 0
                    ? "✔"
                    : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "None", "Nessuno") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  v-if="formData.printTreatment == 1"
                  :disabled="mode === 'view'"
                  id="treatment-1"
                  type="radio"
                  value="1"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label
                  v-if="formData.printTreatment == 1"
                  class="label-input-radio"
                  for="treatment-1"
                  >{{ formData.printTreatment == 1 ? "✔" : "" }}</label
                >
                <div
                  v-if="formData.printTreatment == 1"
                  class="com-anm22-app-text-m"
                  style="margin:0 5px;"
                >
                  {{ $anm22.strLang(lang, "Old flag", "Vecchio flag") }}
                </div>
                <div
                  v-if="formData.printTreatment == 1"
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-lorica"
                  type="radio"
                  value="lorica"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-lorica">{{
                  formData.printTreatment === "lorica" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Lorica", "Lorica") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-transfer"
                  type="radio"
                  value="transfer"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-transfer">{{
                  formData.printTreatment === "transfer" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Transfer", "Transfer") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-uv"
                  type="radio"
                  value="uv"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-uv">{{
                  formData.printTreatment === "uv" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "UV", "UV") }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="wg-row input-row" style="height:36px;">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Colors", "Colori") }}
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">1</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color1"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList(color1)"
                :key="'color1-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color1 == '' ? 'Nessun Colore' : getColorName(color1)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color1qnt"
              placeholder="qnt"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">2</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color2"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList(color2)"
                :key="'color2-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color2 == '' ? 'Nessun Colore' : getColorName(color2)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color2qnt"
              placeholder="qnt"
            />
          </div>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">3</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color3"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList(color3)"
                :key="'color3-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color3 == '' ? 'Nessun Colore' : getColorName(color3)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color3qnt"
              placeholder="qnt"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">4</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color4"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList(color4)"
                :key="'color4-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color4 == '' ? 'Nessun Colore' : getColorName(color4)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color4qnt"
              placeholder="qnt"
            />
          </div>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">5</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color5"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList(color5)"
                :key="'color5-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color5 == '' ? 'Nessun Colore' : getColorName(color5)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color5qnt"
              placeholder="qnt"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">6</div>
            <select
              v-if="mode == 'edit'"
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-select"
              v-model="color6"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList(color6)"
                :key="'color6-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color6 == '' ? 'Nessun Colore' : getColorName(color6)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color6qnt"
              placeholder="qnt"
            />
          </div>
        </div>
      </div>
      <div class="wg-row" v-if="mode === 'prod'">
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="saveForm"
        />
        <div class="vertical-height-div" style="height:10px;"></div>
      </div>
      <!-- NOTE -->
      <div class="wg-row input-row" v-if="mode != 'prod'">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <textarea
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-textarea print-note model-row"
            style="height:100px;width:100%;max-width:unset;"
            v-model.lazy="formData.notes"
          ></textarea>
        </div>
      </div>
      <!-- INVIO NOTIFICHE -->
      <div
        v-if="
          mode != 'prod' &&
            (docs.data.company == 'vrs' || docs.data.company == 'rvt') &&
            (formData.images || formData.notificationDesign)
        "
        class="wg-row input-row no-print"
      >
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Design email", "Email con design") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div
          v-if="notificationSended || formData.notificationDesign"
          class="wg-col wg-xs-12 wg-sm-6"
        >
          <div class="vircos-notification-sended">
            <img :src="$anm22.icons.getWorldIcon('check')" />
            {{ $anm22.strLang(lang, "Sended", "Inviata") }}
            {{
              $moment
                .unix(formData.notificationDesign)
                .format("DD/MM/YYYY HH:mm")
            }}
          </div>
        </div>
        <div v-else class="wg-col wg-xs-12 wg-sm-6">
          <div
            @click="sendShareNotification()"
            class="vircos-notification-send-btn"
          >
            <img :src="$anm22.icons.getWorldIcon('send')" />
            {{ $anm22.strLang(lang, "Send", "Invia") }}
          </div>
        </div>
      </div>
      <div class="wg-row input-row" v-if="mode != 'prod'">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ lastEditDate + " " + lastEditUser }}
          </div>
        </div>
      </div>
      <template v-if="mode === 'edit' || mode === 'prod'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, "Attachment", "Allegato") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <template v-if="graphicImages">
            <div
              v-for="(img, index) in graphicImages.filter((i) => i)"
              :key="'img-' + index"
              style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
            >
              <img
                style="height:100%;width:100%;"
                :src="$anm22.getImagePath(img)"
                @click="showPic(img)"
              />
              <img
                v-if="mode === 'edit'"
                class="com-anm22-app-img-fixed-height-m"
                style="position:absolute;top:3px;right:3px;"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="removeImage(index)"
              />
            </div>
          </template>
          <anm22-file-uploader
            v-if="mode === 'edit'"
            :uploadUrl="
              'vircos/graphics-image?idWorldProject=' + imagesProjectId
            "
            :onSuccess="addImage"
          ></anm22-file-uploader>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" v-if="mode === 'edit'">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveForm"
          />
          <input
            type="button"
            style="margin-left:10px;"
            :value="
              $anm22.strLang(lang, 'Download template', 'Scarica template')
            "
            @click="downloadTemplate"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploaderInline.vue";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mainProjectDocs: {
      type: Object | null,
      default: null,
    },
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      formData: {},
      colorList: [
        { idWarehouseProduct: 134, name: "Bovina Nero Asfalto 09" },
        { idWarehouseProduct: 135, name: "Bovina Grigio Grafite 10" },
        { idWarehouseProduct: 136, name: "Bovina Silver Alluminio 11" },
        { idWarehouseProduct: 137, name: "Bovina Cromato 87" },
        { idWarehouseProduct: 138, name: "Bovina Bianco Ghiaccio 04" },
        { idWarehouseProduct: 139, name: "Bovina Oro 17" },
        { idWarehouseProduct: 140, name: "Bovina Verde Bandiera 22" },
        { idWarehouseProduct: 141, name: "Bovina Verde Fluorescente 24" },
        { idWarehouseProduct: 142, name: "Bovina Azzurro Jerez 01" },
        { idWarehouseProduct: 143, name: "Bovina Blu Metallizzato 02" },
        { idWarehouseProduct: 144, name: "Bovina Blu Scozia 03" },
        { idWarehouseProduct: 145, name: "Bovina Giallo Fluorescente 05" },
        { idWarehouseProduct: 146, name: "Bovina Giallo Corse 14" },
        { idWarehouseProduct: 147, name: "Bovina Arancione Fluorescente 06" },
        { idWarehouseProduct: 148, name: "Bovina Rosso Fluorescente 17" },
        { idWarehouseProduct: 149, name: "Canguro Nero Asfalto 50" },
        { idWarehouseProduct: 150, name: "Canguro Grigio Grafite 51" },
        { idWarehouseProduct: 151, name: "Canguro Silver Alluminio 52" },
        { idWarehouseProduct: 152, name: "Canguro Bianco Ghiaccio 53" },
        { idWarehouseProduct: 153, name: "Canguro Blu Competizione 81" },
        { idWarehouseProduct: 154, name: "Canguro Blu Metallizzato 55" },
        { idWarehouseProduct: 155, name: "Canguro Blu Scozia 54" },
        { idWarehouseProduct: 156, name: "Canguro Blu Riflettente 77" },
        { idWarehouseProduct: 157, name: "Canguro Azzurro Jerez 64" },
        { idWarehouseProduct: 158, name: "Canguro Azzurro Leopard 76" },
        { idWarehouseProduct: 159, name: "Canguro Verde Naturale 66" },
        { idWarehouseProduct: 160, name: "Canguro Verde Fluorescente 58" },
        { idWarehouseProduct: 161, name: "Canguro verde petrolio 82" },
        { idWarehouseProduct: 162, name: "Canguro Ottanio 83" },
        { idWarehouseProduct: 163, name: "Canguro Rosso Misano 70" },
        { idWarehouseProduct: 164, name: "Canguro Rosso Factory 19" },
        { idWarehouseProduct: 165, name: "Canguro Rosso Fluorescente 60" },
        { idWarehouseProduct: 166, name: "Canguro Rosso Scuderia 80" },
        { idWarehouseProduct: 167, name: "Canguro Fucsia 85" },
        { idWarehouseProduct: 168, name: "Canguro Bordeaux 84" },
        { idWarehouseProduct: 169, name: "Canguro Giallo Fluorescente 59" },
        { idWarehouseProduct: 170, name: "Canguro Giallo Corse 56" },
        { idWarehouseProduct: 171, name: "Canguro Arancione Fluorescente 61" },
        { idWarehouseProduct: 172, name: "Canguro Arancione Spielberg 86" },
        { idWarehouseProduct: 173, name: "Canguro Azzurro Gresini" },
        { idWarehouseProduct: 174, name: "Canguro Blu Sasaki" },
        { idWarehouseProduct: 175, name: "Racing Nero Asfalto 50" },
        { idWarehouseProduct: 176, name: "Racing Grigio Grafite 51" },
        { idWarehouseProduct: 177, name: "Racing Silver Alluminio 52" },
        { idWarehouseProduct: 178, name: "Racing Bianco Ghiaccio 53" },
        { idWarehouseProduct: 179, name: "Racing Blu Competizione 81" },
        { idWarehouseProduct: 180, name: "Racing Blu Metallizzato 55" },
        { idWarehouseProduct: 181, name: "Racing Blu Scozia 54" },
        { idWarehouseProduct: 182, name: "Racing Blu Riflettente 77" },
        { idWarehouseProduct: 183, name: "Racing Azzurro Jerez 64" },
        { idWarehouseProduct: 184, name: "Racing Azzurro Leopard 76" },
        { idWarehouseProduct: 185, name: "Racing Verde Naturale 66" },
        { idWarehouseProduct: 186, name: "Racing Verde Fluorescente 58" },
        { idWarehouseProduct: 187, name: "Racing verde petrolio 82" },
        { idWarehouseProduct: 188, name: "Racing Ottanio 83" },
        { idWarehouseProduct: 189, name: "Racing Rosso Misano 70" },
        { idWarehouseProduct: 190, name: "Racing Rosso Factory 19" },
        { idWarehouseProduct: 191, name: "Racing Rosso Fluorescente 60" },
        { idWarehouseProduct: 192, name: "Racing Rosso Scuderia 80" },
        { idWarehouseProduct: 193, name: "Racing Fucsia 85" },
        { idWarehouseProduct: 194, name: "Racing Bordeaux 84" },
        { idWarehouseProduct: 195, name: "Racing Giallo Fluorescente 59" },
        { idWarehouseProduct: 196, name: "Racing Giallo Corse 56" },
        { idWarehouseProduct: 197, name: "Racing Arancione Fluorescente 61" },
        { idWarehouseProduct: 198, name: "Racing Arancione Spielberg 86" },
        { idWarehouseProduct: 199, name: "Racing Azzurro Gresini" },
        { idWarehouseProduct: 200, name: "Racing Blu Sasaki" },
        { idWarehouseProduct: 201, name: "Crosta" },
        { idWarehouseProduct: 202, name: "Rinforzo Crostina" },
      ],
      tabToShow: "default",
      picToShow: null,
      notificationSended: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    color1: {
      get() {
        if (!this.formData.color1 || this.formData.color1 == "") {
          return "";
        } else if (isNaN(this.formData.color1)) {
          return this.findProductIdByLeatherName(this.formData.color1);
        } else {
          return this.formData.color1;
        }
      },
      set(newVal) {
        this.formData.color1 = newVal;
      },
    },
    color2: {
      get() {
        if (!this.formData.color2 || this.formData.color2 == "") {
          return "";
        } else if (isNaN(this.formData.color2)) {
          return this.findProductIdByLeatherName(this.formData.color2);
        } else {
          return this.formData.color2;
        }
      },
      set(newVal) {
        this.formData.color2 = newVal;
      },
    },
    color3: {
      get() {
        if (!this.formData.color3 || this.formData.color3 == "") {
          return "";
        } else if (isNaN(this.formData.color3)) {
          return this.findProductIdByLeatherName(this.formData.color3);
        } else {
          return this.formData.color3;
        }
      },
      set(newVal) {
        this.formData.color3 = newVal;
      },
    },
    color4: {
      get() {
        if (!this.formData.color4 || this.formData.color4 == "") {
          return "";
        } else if (isNaN(this.formData.color4)) {
          return this.findProductIdByLeatherName(this.formData.color4);
        } else {
          return this.formData.color4;
        }
      },
      set(newVal) {
        this.formData.color4 = newVal;
      },
    },
    color5: {
      get() {
        if (!this.formData.color5 || this.formData.color5 == "") {
          return "";
        } else if (isNaN(this.formData.color5)) {
          return this.findProductIdByLeatherName(this.formData.color5);
        } else {
          return this.formData.color5;
        }
      },
      set(newVal) {
        this.formData.color5 = newVal;
      },
    },
    color6: {
      get() {
        if (!this.formData.color6 || this.formData.color6 == "") {
          return "";
        } else if (isNaN(this.formData.color6)) {
          return this.findProductIdByLeatherName(this.formData.color6);
        } else {
          return this.formData.color6;
        }
      },
      set(newVal) {
        this.formData.color6 = newVal;
      },
    },
    color1qnt: {
      get() {
        if (!this.formData.color1qnt || this.formData.color1qnt == "") {
          return "";
        } else {
          return this.formData.color1qnt;
        }
      },
      set(newVal) {
        this.formData.color1qnt = newVal;
      },
    },
    color2qnt: {
      get() {
        if (!this.formData.color2qnt || this.formData.color2qnt == "") {
          return "";
        } else {
          return this.formData.color2qnt;
        }
      },
      set(newVal) {
        this.formData.color2qnt = newVal;
      },
    },
    color3qnt: {
      get() {
        if (!this.formData.color3qnt || this.formData.color3qnt == "") {
          return "";
        } else {
          return this.formData.color3qnt;
        }
      },
      set(newVal) {
        this.formData.color3qnt = newVal;
      },
    },
    color4qnt: {
      get() {
        if (!this.formData.color4qnt || this.formData.color4qnt == "") {
          return "";
        } else {
          return this.formData.color4qnt;
        }
      },
      set(newVal) {
        this.formData.color4qnt = newVal;
      },
    },
    color5qnt: {
      get() {
        if (!this.formData.color5qnt || this.formData.color5qnt == "") {
          return "";
        } else {
          return this.formData.color5qnt;
        }
      },
      set(newVal) {
        this.formData.color5qnt = newVal;
      },
    },
    color6qnt: {
      get() {
        if (!this.formData.color6qnt || this.formData.color6qnt == "") {
          return "";
        } else {
          return this.formData.color6qnt;
        }
      },
      set(newVal) {
        this.formData.color6qnt = newVal;
      },
    },
    useMainProjectImages() {
      if (this.docs && this.docs.data && this.docs.data.mainProjectId) {
        return true;
      } else {
        return false;
      }
    },
    graphicImages() {
      if (this.useMainProjectImages) {
        if (
          this.mainProjectDocs &&
          this.mainProjectDocs.graphics &&
          this.mainProjectDocs.graphics.images
        ) {
          return this.mainProjectDocs.graphics.images;
        }
        return [];
      } else {
        return this.formData.images;
      }
    },
    imagesProjectId() {
      if (this.useMainProjectImages) {
        return this.docs.data.mainProjectId;
      } else {
        return this.project.idWorldProject;
      }
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
  },
  methods: {
    saveForm(notCloseModal) {
      const docs = { ...this.docs };
      docs.graphics = this.formData;
      docs.graphics.lastUser = this.user.idWorldUser;
      docs.graphics.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      if (this.mode !== "prod" && notCloseModal !== true) {
        this.$anm22.eventBus.$emit("wg-modal-close");
      }
    },
    showPic(img) {
      this.picToShow = img;
      this.tabToShow = "pic";
    },
    closePic() {
      this.tabToShow = "default";
      this.picToShow = null;
    },
    addImage(data) {
      if (this.useMainProjectImages) {
        this.addImageToMainProject(data);
      } else {
        this.addImageToCurrentProject(data);
      }
    },
    addImageToMainProject(data) {
      const mainDocs = { ...this.mainProjectDocs };
        if (!mainDocs.graphics.images) {
          mainDocs.graphics.images = [];
        }
        mainDocs.graphics.images.push(data.url);
        mainDocs.graphics.lastUser = this.user.idWorldUser;
        mainDocs.graphics.lastUpdate = this.$moment().unix();
        this.$http
          .post(
            "vircos",
            {
              projectId: this.imagesProjectId,
              docs: mainDocs,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            );
            this.formData.images = response.data.docs.graphics.images;
            this.saveForm(true);
          })
          .catch((error) => {
            /* offline */
          });
    },
    addImageToCurrentProject(data) {
      if (!this.formData.images) {
        this.formData.images = [];
      }
      this.formData.images.push(data.url);
      const docs = { ...this.docs };
      docs.graphics = this.formData;
      docs.graphics.lastUser = this.user.idWorldUser;
      docs.graphics.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.graphics;
        })
        .catch((error) => {
          /* offline */
        });
    },
    removeImage(index) {
      if (this.useMainProjectImages) {
        const docs = { ...this.mainProjectDocs };
        docs.graphics.images.splice(index, 1);
        docs.graphics.lastUser = this.user.idWorldUser;
        docs.graphics.lastUpdate = this.$moment().unix();
        this.$http
          .post(
            "vircos",
            {
              projectId: this.imagesProjectId,
              docs: docs,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            );
          })
          .catch((error) => {
            /* offline */
          });
      } else {
        this.formData.images.splice(index, 1);
        const docs = { ...this.docs };
        docs.graphics = this.formData;
        docs.graphics.lastUser = this.user.idWorldUser;
        docs.graphics.lastUpdate = this.$moment().unix();
        this.$http
          .post(
            "vircos",
            {
              projectId: this.project.idWorldProject,
              docs: docs,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            );
            this.formData = response.data.docs.graphics;
          })
          .catch((error) => {
            /* offline */
          });
      }
    },
    downloadTemplate() {
      this.$http
        .get("https://www.anm22.it/app/tasks/vircos/template-grafiche.pdf", {
          responseType: "blob", // important
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
    selectColorList(color) {
      let colorList = this.colorList;
      return colorList;
    },
    sendShareNotification() {
      if (this.docs.data.email) {
        this.formData.notificationDesign = this.$moment().unix();
        this.notificationSended = true;
        var productImage = null;
        // Cerco l'immagine da allegare
        if (this.formData.images) {
          productImage = this.$anm22.getImagePath(this.formData.images[0]);
        } else {
          console.log("Missing design image");
          return null;
        }
        this.$http
          .post(
            "vircos/sendShareNotification",
            {
              projectId: this.project.idWorldProject,
              email: this.docs.data.email,
              name: this.docs.data.name,
              surname: this.docs.data.surname,
              designImage: productImage,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log("Notification: Missing customer e-mail");
      }
    },
    findProductIdByLeatherName(leatherName) {
      for (let i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].name === leatherName) {
          return this.colorList[i].idWarehouseProduct;
        }
      }
      // Ritorna null se il nome non è stato trovato
      return leatherName;
    },
    getColorName(productId) {
      for (let i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].idWarehouseProduct === productId) {
          return this.colorList[i].name;
        }
      }
      // Ritorna null se il nome non è stato trovato
      return productId;
    },
  },
  created() {
    this.formData = { ...this.docs.graphics };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
  },
  components: {
    Anm22FileUploader,
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.input-qnt-elem {
  max-width: 50px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.pic-viewer {
  height: calc(90vh - 90px);
  width: 100%;
  justify-content: center;
}
.vircos-notification-send-btn {
  cursor: pointer;
  position: relative;
  padding: 6px 12px 6px 32px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  &:hover {
    background-color: #ddd;
  }

  img {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 16px;
  }
}
.vircos-notification-sended {
  position: relative;
  padding: 6px 12px 6px 22px;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  img {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 16px;
  }
}
@media print {
  .model-row {
    width: 541px !important;
    max-width: 541px !important;
  }
  .print-note {
    height: 541px !important;
  }

  .no-print {
    display: none;
  }
}
</style>
